import React from "react";
import { useTranslation } from "react-i18next";

const STARS = "★";

export default function MarqueeStrip() {
  const { t, i18n } = useTranslation();
  const isZh = i18n.language.startsWith("zh");

  const items = isZh
    ? ["手作印度料理", "杜爾希 · 台中", "現磨香料 · 窯烤新鮮", "週二公休 · 現金結帳", "用愛烹煮"]
    : ["Hand-crafted Indian Cuisine", "Tulsi · Taichung", "Fresh ground spices · Tandoor-fired", "Closed Tuesdays · Cash only", "Made with Love"];

  const row = [...items, ...items, ...items];

  return (
    <div
      className="overflow-hidden border-y py-3 select-none"
      style={{
        background: "linear-gradient(90deg, #A90011 0%, #D11D21 50%, #A90011 100%)",
        borderColor: "#8B6F1A",
      }}
      data-testid="marquee-strip"
      aria-hidden="true"
    >
      <div className="marquee-track">
        {row.map((txt, i) => (
          <span key={i} className="font-serif-display text-[#FFFAEF] text-lg md:text-2xl flex items-center mx-6 md:mx-10 whitespace-nowrap tracking-wide">
            <span className="text-[#E5C76B] mr-6 md:mr-10">{STARS}</span>
            <span style={{ fontStyle: "italic" }}>{txt}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
